export const AccessType = {
  Delete: 'delete',
  Insert: 'insert',
  Read: 'read',
  Update: 'update',
} as const;

export type AccessType = (typeof AccessType)[keyof typeof AccessType];
